import React from 'react';
import background from '../images/bg.jpeg';

const TypeWriter = () => {
  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div>
      <div className='py-4   rounded-t-full flex flex-col bg-black ' >
        <div className='flex justify-center  '>
          <p className='text-white font-bold text-2xl'>         שובע שמחות
          </p>
        </div>
        <div className="h-[1px] w-[240px] mx-auto mt-4 bg-line"></div>
      </div>
    </div>
  );
};

export default TypeWriter;
